import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ForecastedCellPropertyHeader = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "100",
    justifyContent: "end",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkDealTable.forecastedCell"
    }), /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkDealTable.forecastedCellTooltip"
      })
    })]
  });
};
export default ForecastedCellPropertyHeader;